const measures = [
  ['Throughput', 'picks / hour'],
  ['Error rate', 'vs. baseline'],
  ['Cost per pick', 'fully loaded'],
  ['Time to live', 'weeks'],
] as const;

export function Proof() {
  return (
    <section className="sec sec--pilot" id="proof">
      <div className="sec__label">Proof on a working floor</div>
      <h2 className="big drift drift--rev">Measured live.<br />Published plainly.</h2>

      <div className="measure-line">
        {measures.map(([name, unit]) => (
          <div className="measure reveal" key={name}><b>{name}</b><span>{unit}</span></div>
        ))}
      </div>
      <p className="visual-caption reveal">We validate in simulation first, then on a working floor in Romania.</p>
    </section>
  );
}
